/**
 * Links de chatweb.
 *
 * E a tela que cria a porta de entrada: para cada fila, um ou varios links,
 * cada um com tipo (site, pagina, convite, integracao) e aparencia propria.
 */
export const nav = {
    permissao: 'atendimento.links:ver',
    section: 'Configuracao',
    title: 'LinksDeChat',
    icon: 'link',
    route: '/links',
    sequence: 13,
};

export default [
    {
        path: '/links',
        name: 'links',
        component: () => import('./pages/LinksPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.links:ver' },
    },
];
